import { render, staticRenderFns } from "./AssuntosEditar.vue?vue&type=template&id=4ef796df&"
import script from "./AssuntosEditar.vue?vue&type=script&lang=js&"
export * from "./AssuntosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports